var map = {
	"./DynamicRegistration/en-US.json": 4443,
	"./DynamicRegistration/es.json": 86864,
	"./Tests/en-US.json": 14598,
	"./Tests/es.json": 2916,
	"./TokenView/en-US.json": 53667,
	"./TokenView/es.json": 26171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67185;